export default __webpack_public_path__ + "static/media/tuft-and-needle-dark.d5a2d56c.svg";